<template>
    <b-container class="rounded-lg">
        <b-form @submit.stop.prevent="submitHandler">
            <b-row >
                <b-col>
                    <label class="text-muted"><small>First Name</small></label>
                    <b-form-input
                        v-model="$v.client.first_name.$model" 
                        :state="validateState('first_name')"
                        placeholder="First Name" 
                        hide-details 
                        dense
                        outlined 
                        class="white"
                    />
                    <form-invalid-feedback type="required" />
                </b-col>
                <b-col>
                    <label class="text-muted"><small>Last Name</small></label>
                    <b-form-input
                        v-model="$v.client.last_name.$model" 
                        :state="validateState('last_name')"
                        placeholder="Last Name" 
                        hide-details 
                        dense
                        outlined 
                        class="white"
                    />
                    <form-invalid-feedback type="required" />
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col>
                    <label class="text-muted"><small>Email Address</small></label>
                    <b-form-input
                        v-model="$v.client.email.$model" 
                        :state="validateState('email')"
                        placeholder="Email Address" 
                        hide-details 
                        dense
                        outlined 
                        class="white"
                    />
                    <form-invalid-feedback type="email" />
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col>
                    <label class="text-muted"><small>Organization</small></label>
                    <b-form-input
                        v-model="$v.client.organization.$model" 
                        :state="validateState('organization')"
                        placeholder="Organization" 
                        hide-details 
                        dense
                        outlined 
                        class="white"
                    />
                    <form-invalid-feedback type="required" />
                </b-col>
            </b-row>
            <b-row class="py-3 mt-3">
                <b-col class="text-right">
                    <b-btn size="sm" variant="outline"  @click="__close_drawer()">Cancel</b-btn>
                    <b-btn 
                        type="submit"
                        class="ml-2 font-weight-bold" 
                        size="sm" 
                        variant="primary"

                    >ADD CLIENT</b-btn>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

import { validationMixin } from 'vuelidate'
import { ModalMixin } from '@/mixins'
export default {
    name: 'ClientForm',
    mixins: [validationMixin, ModalMixin],
    data(){
        return {
            client: {
                first_name: "",
                last_name: "",
                email: "",
                organization: ""
            },
            
        }
    },
    validations(){
        return {
            client: {
                first_name: { required },
                last_name: { required }, 
                email: {required, email},
                organization: {required}
            }
        }
    },
    methods: {
        validateState(name) {
            const { $dirty, $error } = this.$v.client[name];
            return $dirty ? !$error : null;
        },
        submitHandler(){
            this.$v.client.$touch();
            if (this.$v.client.$anyError) return; 
            
            let payload = {
                client: this.client
            }
            this.$store.dispatch('clients/create',{ payload }).then(res=>{
                this.$store.commit('clients/ADD_ITEM', res.data.data)
                this.$eventbus.$emit('after-client-add', res.data.data);
            }).catch(err=>{
                alert(err)
            })
        }
    }
}
</script>